import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getGeneralSettingsLoadingState = (state: RootState): RootState['generalSettings']['loading'] =>
  state.generalSettings.loading

export const generalSettingsLoading = createSelector(
  getGeneralSettingsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getGeneralSettingsData = (state: RootState): RootState['generalSettings']['data'] =>
  state.generalSettings.data
